import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiSave, FiLock, FiExternalLink, FiHelpCircle, FiInfo, FiShield, FiAlertTriangle, FiPlus, FiX, FiSettings } = FiIcons;
import { mockApps, mockAppConfigs, mockAppSecrets } from '../data/mockData';

const AppConfig = () => {
  const [selectedAppId, setSelectedAppId] = useState('app_1');
  const config = mockAppConfigs[selectedAppId] || {};

  return (
    <div className="space-y-6 animate-in fade-in duration-700 pb-12">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <div className="flex items-center gap-3">
            <h2 className="text-2xl font-bold text-slate-800">App Configuration</h2>
            <span className="px-2 py-0.5 bg-slate-100 text-slate-500 text-[10px] font-black uppercase rounded-md border border-slate-200">Placeholder module</span>
          </div>
          <p className="text-sm text-slate-500">Technical endpoints and email identity settings.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <select className="px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm font-medium outline-none shadow-sm" value={selectedAppId} onChange={(e) => setSelectedAppId(e.target.value)} >
            {mockApps.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          <button className="px-6 py-2.5 bg-blue-600 text-white text-sm font-bold rounded-xl hover:bg-blue-700 transition-all shadow-md flex items-center justify-center gap-2 shrink-0">
            <SafeIcon icon={FiSave} /> Save Changes
          </button>
        </div>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-12 text-center">
        <SafeIcon icon={FiSettings} className="text-4xl text-slate-200 mx-auto mb-3" />
        <p className="text-slate-500 text-sm italic">Detailed app-level configuration is currently in the design phase and uses mock data for UI testing.</p>
      </div>
    </div>
  );
};

export default AppConfig;